"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by fanjingjian on 17/9/5.
 */

var getCookie = function getCookie(c_name) {
    var c_start = void 0;
    var c_end = void 0;
    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
};

exports.default = getCookie;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cp-component-lib/lib/getCookie.js
// module id = 240
// module chunks = 0